import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NcteService } from 'src/app/services/ncte/ncte.service';
import { ShowNcteService } from 'src/app/services/showNcte/show-ncte.service';
declare var $:any;
@Component({
  selector: 'app-ncte-item',
  templateUrl: './ncte-item.component.html',
  styleUrls: ['./ncte-item.component.scss']
})
export class NcteItemComponent implements OnInit {

  id:string;
  sub:Subscription;
  urlPath='';
  constructor(private showNcteService:ShowNcteService,
    private route:ActivatedRoute,
    private ncteService:NcteService,
    private router:Router) { 
      showNcteService.hide();
  }

  ngOnInit(): void {
    this.sub=this.route.params.subscribe(
      (params:Params)=>{
        this.id=params['id'];
        const path=this.ncteService.searchNcte(this.id);
        if(path){
          if(path.includes('view?usp=sharing')){
            this.urlPath=path.replace('view?usp=sharing','preview');
            $('#ncteItem').attr('src', this.urlPath);
            this.urlPath=path;
          }else{
            this.urlPath=path;
            $('#ncteItem').attr('src', path);
          
          }
        }else{
          this.router.navigate(['not-found']);
        }
        
        
      }
    )
  }

  ngOnDestroy(): void {
      this.showNcteService.show();
  }
}
